//En este js se gestionarán los dintitos fallos de los campos que vallan surgiendo

//Con está funcion gestionaremos los distintos errores que hay al cambiar campos a tiempo real en el onchange
export const handleChangeErrors = (
  name,
  value,
  estadoCampoReque,
  estadoCampoSintaxis,
  setEstadoCampoReque,
  setestadoCampoSintaxis,
  setEstadosActualizados,
  primerEnvio
) => {
  // Hacemos copias de los estados de validación
  let nuevoEstadoCampoReque = { ...estadoCampoReque };
  let nuevoEstadoCampoSintaxis = { ...estadoCampoSintaxis };

  // Expresiones regulares
  const correoFallido = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  const telefonoFallido = /^(\(?\d{3}\)?[-]?\d{3}[-]?\d{3})$/;


  if (primerEnvio !== false) {
    // Validación de campo vacío
    nuevoEstadoCampoReque[name] = value.trim() === "";

    // Validación de sintaxis según el campo
    if (name === "correo") {
      nuevoEstadoCampoSintaxis["correoMal"] = value.length === 0 ? false : !correoFallido.test(value);
    }

    if (name === "telefono") {
      nuevoEstadoCampoSintaxis["telefonoMal"] = value.length === 0 ? false : !telefonoFallido.test(value);
    }

  }

  // Se envían los cambios de estado
  setEstadoCampoReque(nuevoEstadoCampoReque);
  setestadoCampoSintaxis(nuevoEstadoCampoSintaxis);
  setEstadosActualizados(true);
};

//Funcion que gestiona los los distintos errores que hay al cambiar campos al hacer el submit
//La gestion de errores el la misma que el onChange pero los datos para verificar estos datos 
//En el caso del onchange el nombre a tiempo real y el el caso del submit devemos comprobar el form data
export const handleSubmitErrors = (
  curso,
  camposRequeridos,
  formData,
  estadoCampoReque,
  estadoCampoSintaxis,
  setEstadoCampoReque,
  setEstadoCampoSintaxis,
  setEstadosActualizados
) => {
  let nuevoEstadoCampoReque = { ...estadoCampoReque };
  let nuevoEstadoCampoSintaxis = { ...estadoCampoSintaxis };
  const correoFallido = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  const telefonoFallido = /^(\(?\d{3}\)?[-]?\d{3}[-]?\d{3})$/;


  for (const campo in camposRequeridos) {
    if (!formData[campo] || 
        (typeof formData[campo] === 'string' && formData[campo].trim() === '') || 
        (typeof formData[campo] === 'boolean' && !formData[campo])) {
      nuevoEstadoCampoReque[campo] = true;
    } else {
      nuevoEstadoCampoReque[campo] = false;
    }
  }

  // Validar CAPTCHA por separado ya que no está en formData
  // La validación del CAPTCHA se debe hacer antes de llamar a esta función
  // Aquí solo aseguramos que si el campo captcha existe en estadoCampoReque, mantenemos su estado
  if ('captcha' in estadoCampoReque) {
    // Si captcha ya está como false (fue validado), lo mantenemos
    // Si está como true (no validado), lo mantenemos
    nuevoEstadoCampoReque['captcha'] = estadoCampoReque['captcha'];
  }

  // Validación específica de sintaxis para correo
  if (formData.correo && formData.correo.length > 0) {
    if (!correoFallido.test(formData.correo)) {
      nuevoEstadoCampoSintaxis['correoMal'] = true;
    } else {
      nuevoEstadoCampoSintaxis['correoMal'] = false;
    }
  } else {
    nuevoEstadoCampoSintaxis['correoMal'] = false;
  }

  if (formData.telefono && formData.telefono.length > 0) {
    if (!telefonoFallido.test(formData.telefono)) {
      nuevoEstadoCampoSintaxis['telefonoMal'] = true;
    } else {
      nuevoEstadoCampoSintaxis['telefonoMal'] = false;
    }
  } else {
    nuevoEstadoCampoSintaxis['telefonoMal'] = false;
  }
  


  setEstadoCampoReque(nuevoEstadoCampoReque);
  setEstadoCampoSintaxis(nuevoEstadoCampoSintaxis);

  setEstadosActualizados(true);
  //console.log(nuevoEstadoCampoReque);
  //console.log(nuevoEstadoCampoSintaxis);
};


//En esta funcion comprobaremos si todos los datos introducidos son correcto 
//Es decir que el comprobador de estado ninguno se halla activado a true
export const todosDatosCorrectos = (curso, formData, estadoCampoReque, estadoCampoSintaxis) => {

  //Según la situcación selecionada se desactivarán los ficheros que no son requeridos de esa categoría
  // Verificar si todos los valores de formDataSinCurso están vacíos
  const formDataVacio = Object.values(formData).every(value => value === '');

  //Con esta funcion podremos ver si comprobando todos los campos se han rellenado correctamente,
  //Si no ha saltado ninguna alerta, es decir que no a dado ningun error y por lo tanto el estado esta a false
  //Significará que todos los datos estan introducidos correctamente
  let todosCamposFalse = () => {
    const todosRequeFalse = Object.values(estadoCampoReque).every(valor => valor === false);
    const todosSintaxixFalse = Object.values(estadoCampoSintaxis).every(valor => valor === false);
    // console.log("todosRequeFalse", todosRequeFalse);

    return todosRequeFalse && todosSintaxixFalse && !formDataVacio;
  };
  //En caso de que la funcion anterior nos de false he creado una funcion que nos muestra los campos que 
  //la alerta está activada
  //Funcion opcional
  const camposFalse = () => {
    const camposRequeFalse = [];
    for (const campo in estadoCampoReque) {
      // console.log("campo ", campo);
      // console.log("campo", estadoCampoReque[campo]);
      if (Object.prototype.hasOwnProperty.call(estadoCampoReque, campo) && estadoCampoReque[campo] === true) {
        console.log("campo ", campo);
        camposRequeFalse.push(campo);
      }
    }

    const camposSintaxixFalse = [];
    for (const campo in estadoCampoSintaxis) {
      if (Object.prototype.hasOwnProperty.call(estadoCampoSintaxis, campo) && estadoCampoSintaxis[campo] === true) {
        camposSintaxixFalse.push(campo);
      }
    }

    return {
      camposRequeFalse, camposSintaxixFalse
    };
  };

   console.log("camposAFalso", camposFalse());
   console.log("todosCampos", todosCamposFalse());

  return {
    todosCamposFalse
  };
}